// Full-document render of the Oscar address create/update views:
// PageSkeleton wrapping the legacy stearns breadcrumb shell ("Your Account /
// Your Addresses / Your Address Book") and the UserAddressForm rendered as a
// native React field tree.
import React from "react";

import { templates } from "@reactivated";

import { AccountBreadcrumbShell } from "../components/AccountBreadcrumbShell";
import { AccountForm } from "../components/AccountForm";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.AddressFormDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <AccountBreadcrumbShell
            crumbs={[
                { label: "Your Account", href: props.profile_url },
                { label: "Your Addresses", href: props.address_list_url },
                { label: "Your Address Book" },
            ]}
            heading="Your Address Book"
        >
            <AccountForm {...props} />
        </AccountBreadcrumbShell>
    </PageSkeleton>
);
